import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {  ViewChild } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {ValidateService} from '../../services/validate.service';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes, Router} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
@Component({
  selector: 'app-edit-subusers',
  templateUrl: './edit-subusers.component.html',
  styleUrls: ['./edit-subusers.component.css']
})
export class EditSubusersComponent implements OnInit {
  user:Object;
  user_id;
  userdata:Users[];
  public submitted:boolean;
  workgroups:WorkGroups[];

  edituseremail;
  edituserpassword;

  constructor(private validateService:ValidateService,private router:Router ,private authService:AuthenticationService,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  ngOnInit() {
    this.refreshEverything();
  }
  refreshEverything = ()=>{

    this.user_id = this.route.snapshot.paramMap.get('id');  

    this.getdataService.getUserByID(this.user_id).subscribe((userdata) => {
      this.userdata=  userdata;
      //////console.log(this.meetingdata[0].event_name);
      //console.log(this.userdata)
      this.edituseremail = userdata.email;
     
      
       this.submitted=false;
        },
      err=>{
        //////console.log(err);
        return false;
      }); 


    this.authService.getProfile().subscribe((user) => {
      this.user=  user;
      ////console.log(this.user[0].user.account_ID);

      this.getdataService.getWorkGroupsByAccount(this.user[0].user.account_ID).subscribe((workgroups) => {
        this.workgroups=  workgroups;
        //////console.log(this.meetingrooms);
        // //console.log(this.workgroups);
      },
    err=>{
      //////console.log(err);
      return false;
    });


    },
  err=>{
    //////console.log(err);
    return false;
  });
    //   this.getdataService.getUsersUnderAccountAdmin(this.user[0].user.account_ID).subscribe((subusers) => {
    //     this.subusers=  subusers;
    //     for(let i=0;i<this.subusers.length; i++)
    //     {
    //       for(let p=0;p<this.workgroups.length;p++)
    //       {
    //         //console.log("subuser: ",this.subusers[i].workgroupID )
    //         //console.log("workgroup: ",this.workgroups[p]._id.toString() )
    //         if(this.subusers[i].workgroupID == this.workgroups[p]._id.toString())
    //         {
    //           //console.log("equals")
    //           this.subusers[i].workgroup_name = this.workgroups[p].workgroup_name;
    //         }
    //       }
    //     }
    //   },
    // err=>{
    //   //////console.log(err);
    //   return false;
    // });


//   this.authService.getProfile().subscribe((user) => {
//     this.user=  user;
//     ////console.log(this.user[0].user.account_ID);
//
// err=>{
//   //////console.log(err);
//   return false;
// });
  }

  setSubUser = () => {
    this.submitted=true;
    let edituseremail = this.elem.nativeElement.querySelector('#edituseremail').value;
    let edituserpassword = this.elem.nativeElement.querySelector('#edituserpassword').value;
    let workgroup = this.elem.nativeElement.querySelector('#workgroup').value;
    ////console.log("selected workgroup ID:");
    ////console.log(workgroup);
    let AccountAvailableRooms = [];
    $('#room_checkboxes :checked').each(function() {
      AccountAvailableRooms.push($(this).val());
    });
    var user= {};
    if(edituserpassword == '')
    {
      user = {
        accountID:this.user_id,
        name: edituseremail,
        email: edituseremail,
        username: edituseremail,
        workgroupID:workgroup
      }
    }else{
      user = {
        accountID:this.user_id,
        name: edituseremail,
        email: edituseremail,
        password: edituserpassword,
        username: edituseremail,
        workgroupID:workgroup
      }
    }
    

    ////console.log("this could be a duplicate?");

    if(!this.validateService.validateEmail(edituseremail)){
    this._flashMessagesService.show('Error: Please use a valid email', {cssClass: 'center-align flow-text card-title z-depth-2 white-text red darken-1', timeout:5000});
      //  this.refreshEverything();
        this.submitted=false;
    }else{
      this.validateService.validateDuplicate(edituseremail).subscribe((email_duplicate) => {
      ////console.log(email_duplicate);
        if(email_duplicate.length>1)
        {
            this._flashMessagesService.show('Error: Duplicate email found', {cssClass: 'center-align flow-text card-title z-depth-2 white-text red darken-1', timeout:5000});
          this.submitted=false;
        }else{
          ////console.log("no duplicate");
          this.authService.updateUser(user).subscribe(data =>{
            if(data.success){
              alert('user updated');
              ////console.log("user registered");
              ////console.log(data);
                this.submitted=false;
                this.router.navigate(['/admin/createaccount']);

            }else{
              alert('udpate failed');
                this.submitted=false;
              //this.refreshEverything();
            }

          });
        }

      },
    err=>{
      //////console.log(err);
      return false;
    });

    }

        this.refreshEverything();

    }





}
interface Users{
  _id:number,
  email:string,
  workgroupID:string,
  workgroup_name:string
}

interface WorkGroups{
  _id:number,
  account_ID:string,
  workgroup_name:string
}



// WEBPACK FOOTER //
// ./src/app/components/edit-subusers/edit-subusers.component.ts